import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import Form from 'app/shared/frames/Form';
import React from 'react';
import FormTextInput from 'app/shared/components/form-input/FormTextInput';
import useInputForm from 'app/shared/components/form-input/utilities/use-input-form';
import Button from 'app/shared/components/button/Button';
import { useCreatePaymentMethod } from 'app/core/api/user/api-user';
import { PaymentMethod } from 'app/core/api/repairer/api-repairer.types';
import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath';
import { useHistory } from 'react-router-dom';
import { tap } from 'rxjs/operators';
import _ from 'lodash';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';

export default function UserCardDetails(): JSX.Element {
  useSetPageTitle('Card Details');
  const history = useHistory();

  const {
    request$: createPaymentMethod$,
    sending: submitting,
    error: apiError,
  } = useCreatePaymentMethod();
  const { handleSubmit, inputProps, formState } =
    useInputForm<PaymentMethod>({
      mode: 'onTouched',
      apiError,
    });

  const { showSnack } = useShowInfo();
  const onSubmit = (formValues: PaymentMethod) => {
    if (_.isEmpty(formState.touched)) {
      history.push(`${ConsumerRoutePath.WALLET}`);
      return;
    }
    return createPaymentMethod$({
      ...formValues,
    }).pipe(
      tap(() => {
        showSnack({
          message: 'Card added!',
          alertType: 'info',
        });
        history.replace(ConsumerRoutePath.WALLET);
      })
    );
  };

  return (
    <>
      <Form
        flexStretch
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
      >
        <FormTextInput
          controlName="name"
          placeholder="Name on Card"
          {...inputProps}
        />
        <FormTextInput
          controlName="number"
          placeholder="Card Number"
          {...inputProps}
        />
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex' }}>
            <div>
              <FormTextInput
                controlName="expMonth"
                placeholder="MM"
                {...inputProps}
              />
            </div>
            <div>
              <FormTextInput
                controlName="expYear"
                placeholder="YYYY"
                {...inputProps}
              />
            </div>
          </div>
          <div>
            <FormTextInput
              controlName="cvc"
              placeholder="***"
              {...inputProps}
            />
          </div>
        </div>
        <Button type="submit" pending={submitting}>
          Save
        </Button>
      </Form>
    </>
  );
}
